import { mainApi } from "../api/root-api"
import { getCauses } from "../slices/causesSlice"
import { setError } from "../slices/statusSlice"

export const getCausesList = (token) => {
  const headers = {
    headers: {Authorization: token}
  }
  let payload = {}
  return async ( dispatch ) => {
    await mainApi.get('/info/causes', headers).then(resp => {
      payload = {
        message: 'Cuentas cargadas con éxito',
        status: resp.status
      }
      dispatch(getCauses(resp.data)) 
    }).catch(err => {
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch(setError(payload))
    })
  }
}